import { render, staticRenderFns } from "./EventExpertsWidget.vue?vue&type=template&id=2e10a69c&scoped=true&"
import script from "./EventExpertsWidget.vue?vue&type=script&lang=js&"
export * from "./EventExpertsWidget.vue?vue&type=script&lang=js&"
import style0 from "./EventExpertsWidget.vue?vue&type=style&index=0&id=2e10a69c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e10a69c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
